import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const SubjectExamination = () => {
  return (
    <>
      <Header />

      <Breadcrumb title="Subjects of Examination" midBreadcrumb="Academic" mainBreadcrumb="Subjects of Examination" ></Breadcrumb>
      <div className='inner-page'>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="subhead">Part-I: Compulsory</h3>
              <p>Internal Examination or Internal Assessment: Candidates for the examination will be required to have
                completed satisfactory course in</p>
              <div className="row">
                <div className="col-md-6 timeline">
                  <ul className='listview'>
                    <li>Art Education (Internal Assessment)</li>
                    <li>Work Experience (Internal Assessment)</li>
                  </ul>
                </div>
                <div className="col-md-6 timeline">
                  <ul className='listview'>
                    <li>Physical Education</li>
                    <li>Education in Moral and Spiritual Values</li>
                  </ul>
                </div>
              </div>
              <h3 className="subhead">Part-II: Compulsory</h3>
              <p><b>Group I : External Examination</b></p>
              <p>Pass Certificates will be awarded to candidates who attain the pass standard in all subjects from Group I
                and Group II</p>
              <div className="row g-2 mb-3">
                <div className="col-12">
                  <h3 className="subhead">Subjects of Examination from Class Nursery to K. G. II</h3>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Hindi</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>English</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Maths</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Colouring</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Gen. Knowledge</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <h3 className="subhead" data-aos="fade-left" data-aos-duration="1000">Subjects of Examination from Class I to VIII
              </h3>
              <div className="row g-2 mb-3">
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book1.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Hindi</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book1.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Maths</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book1.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>English</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book1.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Computer</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book1.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Moral science</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book1.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>General Knowledge</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book1.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Environmental Science</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <h3 className="subhead" data-aos="fade-left" data-aos-duration="1000">Subjects of Examination from Class IX & X
              </h3>
              <div className="row g-2 mb-3">
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book2.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Mathematics</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book2.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Science</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book2.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>English</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book2.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Hindi</h6>
                  </div>
                </div>
                <div className="col" data-aos="fade-left" data-aos-duration="1000">
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book2.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Social Science</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book2.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>Comp. App.</h6>
                  </div>
                </div>
                <div className="col" >
                  <div className="p-3 border bg-light club">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/book2.png"
                      className="img-fluid mx-auto d-block lazyload" data-sizes="auto" data-threshold="1" data-expand='10'
                      alt="matamariamjansevavidyalayas" />
                    <h6>IT (Class IX)</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <h3 className="subhead">Information Technology (Class IX)</h3>
              <div className="timeline">
                <ul>
                  <li>Fine Arts</li>
                </ul>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12">
                  <p><strong>External Examination (PCM)</strong></p>
                  <ul className="list">
                    <li>English</li>
                    <li>Physics</li>
                    <li>Chemistry</li>
                    <li>Mathematics</li>
                    <li>Physical Education</li>
                    <li>Music</li>
                  </ul>
                </div>
                <div className="col-lg-4 col-12">
                  <p><strong>External Examination (PCB)</strong></p>
                  <ul className="list">
                    <li>English</li>
                    <li>Physics</li>
                    <li>Chemistry</li>
                    <li>Biology / Mathematics</li>
                    <li>Physical Education</li>
                    <li>Music</li>
                  </ul>
                </div>
                <div className="col-lg-4 col-12">
                  <p><strong>External Examination (BCE)</strong></p>
                  <ul className="list">
                    <li>English</li>
                    <li>Business Studies</li>
                    <li>Economics</li>
                    <li>Accountancy</li>
                    <li>Mathematics/Physical Education</li>
                    <li>Music</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default SubjectExamination